import React from "react";
import PropTypes from "prop-types";
import Button from "../shared/button/Button";
import HiddenFormFields from "./HiddenFormFields";

const Checkout = (props) => {
  const {
    authenticityToken,
    buttonName,
    currency,
    customFields,
    displayPrice,
    email,
    id,
    name,
    planClass,
    price,
    publishableKey,
    taxPercent,
  } = props;
  const dataButtonId = `payola-button-${planClass}-${id}`;
  const errorDivId = `${dataButtonId}-errors`;
  const planDescription = `${name} (£${displayPrice.toFixed(2)} per month)`;
  const action = `/payola/subscribe/${planClass}/${id}`;
  const buttonClasses =
    "stripe-button-el btn subscription-link payola-subscription-checkout-button";

  return (
    <form
      data-base_path="/payola"
      data-form_id={`${dataButtonId}-form`}
      /* eslint-disable */
      data_error_div={`${dataButtonId}-errors`}
      /* eslint-enable */
      data-plan_class={planClass}
      data-plan_id={id}
      data-quantity="1"
      data-price={price}
      data-name={name}
      data-description={planDescription}
      data-currency={currency}
      data-tax_percent={taxPercent}
      data-plan_image_path=""
      data-publishable_key={publishableKey}
      data-panel_label=""
      data-allow_remember_me={false}
      data-email={email}
      data-verify_zip_code={false}
      data-billing_address={false}
      data-shipping_address={false}
      data-signed_custom_fields={customFields}
      id={`${dataButtonId}-form`}
      action={action}
      method="post"
      acceptCharset="UTF-8"
      data-button_id={dataButtonId}
    >
      <HiddenFormFields authenticityToken={authenticityToken} />
      <Button
        primary
        buttonName={buttonName}
        id={dataButtonId}
        classes={buttonClasses}
        dataTestId="checkout-button"
      />
      <div
        className="payola-error-target"
        style={{ display: "none" }}
        id={errorDivId}
      />
    </form>
  );
};

Checkout.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  customFields: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  planClass: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  displayPrice: PropTypes.number.isRequired,
  publishableKey: PropTypes.string.isRequired,
  taxPercent: PropTypes.number.isRequired,
};

export default Checkout;
